<template>
  <div class="app__wrapper max-w-appMaxWidth flex flex-col my-0 mx-auto min-h-screen"
       :data-in-car="isLandscape" 
       :class="{ 'in-car': isLandscape }"
  >
    <RydLoadingOverlay v-if="isLoading" />
    <div v-if="tokenIsInvalid" class="py-10 px-4 rp-fs-15-ln text-left pb-6">
      <RydIcon icon="symbols/error-exclamation" />
      <p class="font-bold py-2">
        {{ t('errors.generic.title_1') }}
      </p>
      <p>{{ t('errors.generic.text') }}</p>
    </div>
    <router-view v-else />
  </div>
  <div id="teleportBeforeFooter" class="w-screen sticky bottom-0 mx-auto" />
</template>

<script setup lang="ts">
import RydLoadingOverlay from "./components/RydLoading/RydLoadingOverlay.vue";
import RydIcon from '@/components/RydIcon/RydIcon.vue';

import { checkAndApplyTheme, removeTheme } from '@/utils/utils';
import { useAuthStore } from '@/store/auth/auth';

import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { on } from "events";

const authState = useAuthStore();
const route = useRoute();
const tokenIsInvalid = computed(() => authState.tokenIsInvalid);

const isLoading = computed(() => authState.isLoading);
const isLandscape = computed(() => route.query.inCarDevice === "true");

const newUIPages = ['/cars', '/register', '/login', '/change-tmp-password', '/forgotten-password', '/tutorials', '/beta-test'];
onMounted(() => {
  if (newUIPages.some(path => window.location.pathname.startsWith(path))) {
    checkAndApplyTheme();
  } else {
    removeTheme();
  }

});
</script>
<style lang="scss">
  @import url('@/assets/styles/cssVariables.css');
  @import url('@/assets/styles/colorVariables.css');
  @import url('@/assets/customThemes/partnerThemes.css');
  
  #app {
    @apply text-fs-body w-full min-h-full relative font-normal bg-primary-background text-primary-text;

    .app__wrapper.in-car {
        max-width: var(--appMaxWidthLandscape);
      }
  }

  // Remove the following css when new UI completely integrated
  #app.light ,
  #app.dark {
    @apply bg-ryd-background text-ryd-text;

    & #ryd-header {
      @apply bg-ryd-background text-ryd-text
    }

  }
</style>
